import React from 'react';
import { RangeSlider } from '../controls/RangeSlider.jsx';
import { Sparkles, Wand2 } from 'lucide-react';

export function UpscalerControls({
  creativity,
  onChangeCreativity,
  resemblance,
  onChangeResemblance,
  scaleFactor,
  onChangeScaleFactor,
  onTriggerUpscale,
  isProcessing
}) {
  const SCALE_OPTIONS = ['2x (1080p)', '4x (4K Ultra)', '8x (8K Master)'];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <div style={{
        padding: '12px',
        background: 'rgba(168,85,247,0.06)',
        borderRadius: '10px',
        border: '1px solid rgba(168,85,247,0.2)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#c084fc', fontSize: '12px', fontWeight: 700, marginBottom: '4px' }}>
          <Sparkles size={14} /> AI Super-Resolution 4K/8K
        </div>
        <p style={{ fontSize: '11px', color: '#94a3b8', lineHeight: '1.4' }}>
          Reconstruye texturas dérmicas, iluminación de poros y microdetalles cinematográficos de tu avatar personal.
        </p>
      </div>

      <RangeSlider
        label="Creatividad Generativa"
        value={creativity}
        min={0}
        max={100}
        unit="%"
        leftHint="Fiel al original"
        rightHint="Alucinación / Textura"
        onChange={onChangeCreativity}
      />

      <RangeSlider
        label="Fidelidad / Identidad Facial"
        value={resemblance}
        min={50}
        max={100}
        unit="%"
        leftHint="Flexible"
        rightHint="100% Idéntico"
        onChange={onChangeResemblance}
      />

      <div>
        <label style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.6px', color: '#94a3b8', display: 'block', marginBottom: '8px' }}>
          Factor de Escalado
        </label>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
          {SCALE_OPTIONS.map((opt) => {
            const isSelected = scaleFactor === opt;
            return (
              <button
                key={opt}
                type="button"
                onClick={() => onChangeScaleFactor(opt)}
                style={{
                  padding: '8px 4px',
                  borderRadius: '8px',
                  fontSize: '11px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  background: isSelected ? 'rgba(168,85,247,0.18)' : '#141724',
                  color: isSelected ? '#c084fc' : '#94a3b8',
                  border: isSelected ? '1px solid rgba(192,132,252,0.6)' : '1px solid rgba(255,255,255,0.06)',
                  transition: 'all 0.15s ease'
                }}
              >
                {opt}
              </button>
            );
          })}
        </div>
      </div>

      <button
        type="button"
        onClick={onTriggerUpscale}
        disabled={isProcessing}
        style={{
          width: '100%',
          padding: '14px',
          borderRadius: '10px',
          background: 'linear-gradient(135deg, #a855f7 0%, #6366f1 100%)',
          color: '#fff',
          fontWeight: 700,
          fontSize: '14px',
          border: 'none',
          cursor: isProcessing ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          boxShadow: '0 4px 20px rgba(168, 85, 247, 0.4)',
          transition: 'all 0.2s',
          marginTop: 'auto'
        }}
      >
        <Wand2 size={16} />
        {isProcessing ? 'Escalando a 4K...' : '⚡ Reconstruir en 4K Ultra'}
      </button>
    </div>
  );
}
